/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_ActionsInputs */

const en_us2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const pt_br2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

const es_419_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

const pt_pt2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

const fr_fr2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_de2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const it_it2_search_group_actions = /** @type {(inputs: Search_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Search_Group_ActionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_actions = /** @type {((inputs?: Search_Group_ActionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_ActionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_actions(inputs)
	if (locale === "es-419") return es_419_search_group_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_actions(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_actions(inputs)
	if (locale === "de-DE") return de_de2_search_group_actions(inputs)
	if (locale === "it-IT") return it_it2_search_group_actions(inputs)
	return en_us2_search_group_actions(inputs)
});
export { search_group_actions as "search.group_actions" }